export default "__VITE_ASSET__CcwdL_5A__"